import api from '@/core/api/client';

export interface ChannelAvailability {
  whatsappCloud: boolean;
  messenger: boolean;
  instagram: boolean;
}

export interface ChannelAvailabilityOverride {
  whatsappCloud?: boolean;
  messenger?: boolean;
  instagram?: boolean;
}

/**
 * Service de Channel Availability — gate global per-canal + override per-tenant.
 *
 * - Global: aplica a todos os tenants (default TRUE)
 * - Override: per-tenant boolean (força ON/OFF) ou null (remove → usa global)
 *
 * Resolução final no backend:
 *   override === true   → ALLOW
 *   override === false  → DENY
 *   override undefined  → fall to global
 */
export const metaChannelAvailabilityService = {
  // ---------- Global ----------

  async getGlobal(): Promise<ChannelAvailability> {
    const res = await api.get('/meta-channels/availability');
    return res.data;
  },

  async setGlobal(patch: Partial<ChannelAvailability>): Promise<ChannelAvailability> {
    const res = await api.patch('/meta-channels/availability', patch);
    return res.data;
  },

  // ---------- Override per-tenant ----------

  async getTenantOverride(companyId: string): Promise<ChannelAvailabilityOverride> {
    const res = await api.get(`/companies/${companyId}/meta-channel-overrides`);
    return res.data;
  },

  /**
   * patch: { whatsappCloud?: true | false | null, ... }
   *   boolean → force ON/OFF pra esse tenant
   *   null    → remove override desse canal (volta a usar global)
   */
  async setTenantOverride(
    companyId: string,
    patch: Partial<Record<keyof ChannelAvailability, boolean | null>>,
  ): Promise<ChannelAvailabilityOverride> {
    const res = await api.patch(`/companies/${companyId}/meta-channel-overrides`, patch);
    return res.data;
  },

  async clearTenantOverride(companyId: string): Promise<void> {
    await api.delete(`/companies/${companyId}/meta-channel-overrides`);
  },
};
